/* Sugandhya cart helper
 * - SGCart.refresh(open): re-renders every cart (drawer + cart page) after a custom add, and opens the drawer.
 * - SGCart.add(items, open): adds items then refreshes.
 * - Free-gift sync: reads the state that snippets/sg-cart-boost renders into the cart and adds / removes
 *   gift lines (hidden property _sg_gift) so the cart always matches the gift tiers.
 * Checkout is untouched: the drawer's normal Checkout button is picked up by the fastrr checkout script.
 */
(function () {
  if (window.SGCart) return;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var syncing = false;
  var lastSig = '';

  function sectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) {
      if (ids.indexOf(el.dataset.sectionId) < 0) ids.push(el.dataset.sectionId);
    });
    return ids;
  }

  function json(url, body) {
    var opts = body
      ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }
      : { headers: { Accept: 'application/json' } };
    return fetch(url, opts).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw j; return j; });
    });
  }

  function drawer() {
    var d = document.querySelector('cart-drawer-component');
    return d && typeof d.open === 'function' ? d : null;
  }

  // quiet = true: update the cart UI without the drawer's add-to-cart sound / auto-open
  function refresh(open, quiet) {
    var ids = sectionIds();
    var sec = ids.length ? json(root + '?sections=' + ids.join(',')) : Promise.resolve({});
    return Promise.all([sec, json(root + 'cart.js')]).then(function (res) {
      var sections = res[0] || {}, cart = res[1];
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: { resource: cart, sourceId: 'sg-cart', data: { source: 'sg-cart', itemCount: cart.item_count, sections: sections, didError: !!quiet } }
      }));
      if (open) {
        var d = drawer();
        if (d) d.open();
        else if (!/\/cart\/?$/.test(location.pathname)) location.href = root + 'cart';
      }
      setTimeout(syncGifts, 50);
      return cart;
    });
  }

  function add(items, open) {
    return json(root + 'cart/add.js', { items: items }).then(function () { return refresh(open !== false); });
  }

  function readState() {
    var nodes = document.querySelectorAll('script[data-sg-cart-state]');
    if (!nodes.length) return null;
    try { return JSON.parse(nodes[nodes.length - 1].textContent); } catch (e) { return null; }
  }

  // Keep free-gift lines in step with the tiers
  function syncGifts() {
    if (syncing) return;
    var st = readState();
    if (!st) return;
    var sig = JSON.stringify(st);
    if (sig === lastSig) return;
    lastSig = sig;

    var have = {};
    (st.gifts || []).forEach(function (g) { have[g.tier] = g; });
    var adds = [], changes = [];
    (st.tiers || []).forEach(function (t) {
      var g = have[t.id];
      if (t.on && t.ok && !g) adds.push({ id: t.v, quantity: 1, properties: { _sg_gift: t.id } });
      if (g && !t.on) changes.push({ id: g.key, quantity: 0 });
      if (g && t.on && g.qty !== 1) changes.push({ id: g.key, quantity: 1 });
      delete have[t.id];
    });
    // gift lines whose tier no longer exists
    Object.keys(have).forEach(function (k) { changes.push({ id: have[k].key, quantity: 0 }); });
    if (!adds.length && !changes.length) return;

    syncing = true;
    var chain = Promise.resolve();
    changes.forEach(function (c) { chain = chain.then(function () { return json(root + 'cart/change.js', c); }); });
    if (adds.length) chain = chain.then(function () { return json(root + 'cart/add.js', { items: adds }); });
    chain
      .catch(function (e) { console.warn('[sg-cart] gift sync', e); })
      .then(function () { syncing = false; return refresh(false, true); });
  }

  // one-tap upsell buttons inside the cart
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-sg-cart-add]');
    if (!b) return;
    e.preventDefault();
    if (b.disabled) return;
    var label = b.textContent;
    b.disabled = true; b.textContent = 'Adding…';
    add([{ id: +b.getAttribute('data-sg-cart-add'), quantity: 1 }], false).catch(function () { b.disabled = false; b.textContent = label; });
  });

  var t;
  document.addEventListener('cart:update', function () { clearTimeout(t); t = setTimeout(syncGifts, 120); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncGifts);
  else syncGifts();

  window.SGCart = { refresh: refresh, add: add, syncGifts: syncGifts };
})();
